import moment from 'moment/moment';
import { mapGender } from '../../helpers/gender';
import {
  CITIZENSHIP_VALUES,
  MAIN_DATA_FIELD_NAMES,
} from '../../constants/citizenship';
import { DATE_FORMAT } from '../../helpers/date';

/* eslint-disable camelcase */
const mainDataChildSerializer = (data, parentData) => {
  const {
    snils_number,
    name,
    surname,
    patronymic,
    gender: childGender,
    birthdate: childBirthdate,
    citizenship,
  } = data;

  const gender = mapGender(childGender);
  const birthdate = childBirthdate
    ? moment(childBirthdate, DATE_FORMAT).format(DATE_FORMAT)
    : null;

  const getCitizenship = (data) => {
    const { birth_certificate_number, foreign_birth_certificate_number } = data;

    if (birth_certificate_number && foreign_birth_certificate_number) {
      return CITIZENSHIP_VALUES[1];
    }
    if (!birth_certificate_number && foreign_birth_certificate_number) {
      return CITIZENSHIP_VALUES[2];
    }
    return CITIZENSHIP_VALUES[0];
  };

  return {
    snils: snils_number || '',
    data: {
      firstName: name,
      lastName: surname,
      middleName: patronymic || '',
      gender,
      phone: parentData.phone || '',
      email: parentData.email || '',
      birthdate,
      citizenship: citizenship || getCitizenship(data),
      snils: snils_number || '',
      [MAIN_DATA_FIELD_NAMES.birthRegistrationPlace]: '',
    },
    editableFields: {
      firstName: !name,
      lastName: !surname,
      // Если в ЕЛК нет отчества, то так и нужно,
      // Даем редактировать только в случае, когда у пользователя пустое ФИО
      middleName: !name && !surname && !patronymic,
      gender: !gender,
      phone: !parentData.phone,
      email: !parentData.email,
      birthdate: !birthdate,
      citizenship: !citizenship,
      snils: !snils_number,
      [MAIN_DATA_FIELD_NAMES.birthRegistrationPlace]: true,
    },
  };
};
/* eslint-enable camelcase */

export default mainDataChildSerializer;
